import { accessor } from 'src/store';

export function getSocketTypeForVarId (varId: string): 'string' | 'number' | 'boolean' | 'varValue' {
    const variable = accessor.appletDesign.allAppletVariables[varId];
    if (!variable) {
        return 'varValue';
    }
    switch (variable.type) {
        case 'str':
            return 'string';
        case 'num':
            return 'number';
        case 'bool':
            return 'boolean';
        case 'empty':
            return 'varValue';
        default:
            // eslint-disable-next-line unused-imports/no-unused-vars, no-case-declarations
            const check: never = variable;
            return 'varValue';
    }
}
